import DealShowcase from './DealShowcase'

export default DealShowcase
